/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'cross': {
    width: 16,
    height: 16,
    viewBox: '0 0 100 100',
    data: '<path pid="0" d="M75.457 24.543a2 2 0 0 0-2.828 0l-22.63 22.629-22.628-22.629a2 2 0 1 0-2.828 2.828l22.629 22.63-22.63 22.628a2 2 0 1 0 2.829 2.828L50 52.828l22.629 22.63a2 2 0 1 0 2.828-2.829L52.828 50l22.629-22.629a2 2 0 0 0 0-2.828z"/>'
  }
})
